export default "__VITE_ASSET__8065f753__"